import Vue from 'vue'
import Vuex from 'vuex'

import { authentication } from './authentication'
import { twoFactor } from './two-factor'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    authentication,
    twoFactor
  }
})
